import React from "react";
import { NavLink } from "react-router-dom";

import { useClearLibraryFilters } from "hooks/useClearFilters";

export function LibraryName({ value, dependentValues }){
	const clearFilters = useClearLibraryFilters();
	return (
		<span title={value}>
			<NavLink
				to={`/library/${dependentValues.id}/`}
				className="name-overflow"
				onClick={clearFilters}
			>
				{value}
			</NavLink>
		</span>
	);
}


const LibraryNameCell = {
	key: "name",
	cellClass:"link-cell cypress-creative-library-name",
	name: "Creative Library",
	resizable:true,
	sortable:true,
	formatter:LibraryName,
	getRowMetaData(data){
		return { id:data.id };
	},
};

export default LibraryNameCell;
